// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cke_button__image3_icon {\n    background: url('https://cdn.ckeditor.com/4.16.1/standard-all/skins/moono-lisa/icons.png?t=L4K9') no-repeat 0 -1248px!important; \n}\n", ""]);
// Exports
module.exports = exports;
